<script>
    import PreviewElement from "./PreviewElement";
    import SocialLinksWrapperElement from "../../components/pagesbuilder/elements/SocialLinksWrapperElement";

    export default {
        name: "PreviewSocialLinksWrapperElement",
        mixins: [
            PreviewElement,
            SocialLinksWrapperElement
        ]
    }
</script>